// react
import React, { Component } from 'react';

// third-party
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';

// application
import StroykaSlick from '../shared/StroykaSlick';

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
};

class BlockBannerSlideShow2 extends Component {
    state = {
        slides: [],
    };

    componentDidMount() {
        const getOnGoing = async () => {
            try {
                const result = await axios({
                    method: 'POST',
                    url: `${process.env.REACT_APP_HOST_API}/iklan-ecommerce/carousel3`,
                    data: {
                        page: 1,
                        per_page: 10,
                    },
                });
                if (result.data && result.data.response) {
                    this.setState({ slides: result.data.response });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getOnGoing();
    }

    render() {
        const { slides } = this.state;

        if (!slides || slides.length === 0) {
            return null;
        }

        const settings = {
            ...slickSettings,
            dots: slides.length > 1,
        };

        return (
            <div className="block block-promo-banner-slider">
                <div className="container">
                    <div className="promo-banner-slider__wrapper">
                        <StroykaSlick {...settings}>
                            {slides.map((slide, index) => (
                                <div key={slide.id || index} className="promo-banner-slide">
                                    <picture>
                                        <source
                                            media="(max-width: 575px)"
                                            srcSet={slide.url_mobile || slide.url_web}
                                        />
                                        <img
                                            src={slide.url_web}
                                            alt={`Promo Hokky ${index + 1}`}
                                            className="promo-banner-slide__img"
                                            loading={index === 0 ? 'eager' : 'lazy'}
                                        />
                                    </picture>
                                </div>
                            ))}
                        </StroykaSlick>
                    </div>
                </div>
            </div>
        );
    }
}

BlockBannerSlideShow2.propTypes = {
    locale: PropTypes.string,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockBannerSlideShow2);
